import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];

export const fetchAsyncAddOrgnization = createAsyncThunk(
  "/fetchAsyncAddOrgnization",
  async (data) => {
    try {
      const response = await axiosInstance.post('/organization/add', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncUpdateOrganization = createAsyncThunk(
  "/fetchAsyncUpdateOrganization",
  async (data) => {
    console.log(data,'data')
    try {
      const response = await axiosInstance.post(`${API_URL}/organization/update/${data.id}`, data.editData);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetOrganization = createAsyncThunk(
  "/fetchAsyncGetOrganization",
  async () => {
    try {
      let url = `${API_URL}/organization/get`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetOrganizationUsers = createAsyncThunk(
  "/fetchAsyncGetOrganizationUsers",
  async () => {
    try {
      let url = `${API_URL}/organization/get-organization-user`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);


const AllOrganizationSlice = createSlice({
  name: "organizationData",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncGetOrganization.pending]: (state) => {},
    [fetchAsyncGetOrganization.fulfilled]: (state, { payload }) => {
      return payload;
    },
  },
});

export const getAllOrganization = (state) => state.organizationData;

export default AllOrganizationSlice.reducer;
